// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EditProcess_Wrapper__2QXDV","Name":"EditProcess_Name__2D0E-","SectionHeader":"EditProcess_SectionHeader__2cGBS"};